// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".virtual-positions-list .header{padding:15px 10px;text-align:left!important}.virtual-positions-list .header__column{font-size:12px;font-weight:400;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;color:var(--text-disable);justify-content:flex-start}.earn{color:var(--main-green)}.earn.red{color:var(--main-red)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
